import { Container, Typography } from "@material-ui/core";

export function NotFound() {
  return (
    <Container style={{ paddingTop: 25 }}>
      <Typography variant="h1">404: Page Not Found</Typography>
    </Container>
  );
}